<template>
     <div v-if="locationNetworkSummaryPage.locationNode">
    <v-divider></v-divider>
         <v-toolbar flat color="white">
             <h2 class="heading dark-grey--text px-4 py-2">Transactions: {{locationNetworkSummaryPage.name}}</h2>
         </v-toolbar>
      <transactions
        :locationid="null"
        :locationnodeid="locationNetworkSummaryPage.locationNodeId"
        :locationnetworkid="this.$route.params.locationNetworkId"
        :switchingcentreid="locationNetworkSummaryPage.locationNode.switchingCentreId"
        :transactions="networkTransactions"
        :partners="Partners"
        :descriptionlist="descriptionList"
        :salesvalue="salesValue"
        :cosvalue="cosValue"
        :expensevalue="expenseValue"
        :loanvalue="loanValue"
        :isloading="isLoading"
        @refreshTotals="sum()"
        @transactionAdded="getTransactions()"
        :key="networkTransactions.length"
      ></transactions>
    </div>
</template>
<script>
import Api from "@/services/Api";
import Transactions from "@/components/Transactions.vue";
export default {
    props: ["locationnetworksummary"],
    components: {
        transactions: Transactions,
    },
    data(){
        return {
            activeTabName: null,
            customer: "",
      chosenIspsArray: [],
      chosenIsps: [],
      Partners: [{ id: 1, name: "Fibre Geeks" }],
      Isps: [],
      descriptionList: [],
      activeServiceAccounts: [],
      networkHasFnoPackages: false,
      isLoading:true,
      packagesFnoCats: [],
      fibreFarmers: [],
      chosenFnoCats: [],
      deviceSearch: null,
      packageFnoCatsArrays: [],
      showDetails: true,
      Customers: [],
      networkTransactions: [],
      speedProfilesArray: [],
      loading: false,
      expand: false,
      search: "",
      dialog: false,
      pagination: {},
      networkServiceAccounts: [],
      allPackagesFnoLocationNetworks: [],
      speedProfiles: [],
      locationNetworkSummaryPage: [],
      allFibreFarmers: [],
      packagesFnoCat: [],
      locationNodes: [],
      locationUnitData: null,
      takeUpPercentage: null,
      locationUnitDataChartOptions: null,
      packagesFnoLocationNetworks: [],
      nodeDevices: [],
      networkDevices: [],
      packageIspLocationNetworks: [],
      totals: [],
      salesValue: 0,
      cosValue: 0,
      expenseValue: 0,
      loanValue: 0,
      networkDevices: [],
      passiveInstallsComplete: [],
      activeInstallsComplete: [],
      onceoffDataIncome: [],
      onceoffDataCosts: [],
      recurringDataIncome: [],
      recurringDataCosts: [],
        }
    },
    created(){
        this.initialize();
    },
    watch: {
    dialog(val) {
      val || this.close();
    },

    // "$route.query": {
      
    //   immediate: true,
    //   handler(value) {
    //     this.isLoading=true
    //     if (this.$route.query.transactionSearch) {
    //       let frequency = null;
    //       if (value.frequency == "Recurring") {
    //         frequency = true;
    //       } else if (value.frequency == "Once-Off") {
    //         frequency = false;
    //       }
    //       Api()
    //         .get(
    //           "/transactions/byNetwork/" + this.$route.params.locationNetworkId,
    //           {
    //             params: {
    //               from: value.from,
    //               to: value.to,
    //               description: value.description,
    //               transactionType: value.transactionType,
    //               frequency: frequency
    //             }
    //           }
    //         )
    //         .then(response => {
    //           this.networkTransactions = response.data;
    //           this.sum();
    //           this.isLoading=false
    //         });
    //     }
       
    //   }
    // }
  },
  methods:{
      logout() {
      this.drawer = false;
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setPermission", null);
      this.$store.dispatch("setCustomerId", null);
      this.$store.state.isUserLoggedIn = false;
      this.$router.push("/login");
    },
  async getTransactions() {
    this.isLoading=true
      this.descriptionList = [];
      await Api()
        .get("/transactions/fibreFarmer/byNetwork/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.networkTransactions = response.data;
          for (let i = 0; i < this.networkTransactions.length; i++) {
            if (
              !this.descriptionList.includes(
                this.networkTransactions[i].description
              )
            ) {
              this.descriptionList.push(
                this.networkTransactions[i].description
              );
            }
          }
          this.sum();
          this.isLoading=false
        });
    },
    sum() {
      this.totals = [];
      this.salesValue = 0;
      this.cosValue = 0;
      this.expenseValue = 0;
      this.loanValue = 0;
      var res = {};

      this.networkTransactions.forEach(function(el) {
        res[el.transactionType] = res[el.transactionType]
          ? (res[el.transactionType] += +el.amount)
          : +el.amount;
      });
      // for (let i=0; i< res.length;i++){

      // }
      this.totals.push(
        Object.keys(res).map(function(el) {
          return { transactionType: el, amount: res[el] };
        })
      );
      for (let i = 0; i < this.totals[0].length; i++) {
        if (this.totals[0][i].transactionType === "Sales") {
          this.salesValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Cost of Sales") {
          this.cosValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Expense") {
          this.expenseValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Loan") {
          this.loanValue = this.totals[0][i].amount;
        }
      }
    },
    initialize() {
      this.getTransactions();
      this.fetchLocationNetworkSummaryPage();
    },
    fetchLocationNetworksLocations() {
      Api()
        .get("/locationNetworks/fibreFarmer/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.locationNetworksLocations = response.data[0].locations;
          this.installsCalculation();
        });
    },
    installsCalculation() {
      this.passiveInstallsComplete = this.locationNetworksLocations.filter(
        function(el) {
          return el.fibrePulled === true;
        }
      );
      this.activeInstallsComplete = this.locationNetworksLocations.filter(
        function(el) {
          return el.equipmentInstalled === true;
        }
      );
    },
    fetchLocationNetworkSummaryPage() {
      Api()
        .get("/locationNetwork/fibreFarmer/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.locationNetworkSummaryPage = response.data;
          console.log(this.locationNetworkSummaryPage)
        });
    },
  }
}
</script>

